<template>
  <label
    class="label"
    :for="id"
  >
    <slot name="default" /><span
      v-if="required"
      class="mandatory"
    >
      *
    </span>
    <span
      v-if="$slots.afterLabel"
      class="label-after"
    >
      <slot name="afterLabel" />
    </span>
  </label>
</template>

<script setup lang="ts">
defineProps<{
  id: string;
  required: boolean;
}>();
</script>

<style lang="scss" scoped>
.label {
  display: block;
  font-size: map-get($font-sizes, 'm');
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  cursor: pointer;
  pointer-events: none;
}

.label-after {
  margin-left: $pad * 0.25;
}
</style>
